import { axiosConfig } from "../../../../../lib/AxiosConfig";



/***
 * HEADQUARTERS
 */
export const getAllHQBanks = () => {

    // var getAllBanksFromAPI = function (userid) {
        return new Promise(async function (resolve, reject) {
            try{
                let allBanks = axiosConfig.get("http://localhost:8080/bankcompany/allbanks");
                
                console.log(allBanks);
                resolve(allBanks);
                return allBanks;
            }catch(e){
                console.log(e);
                reject(Error("It broke"));
            }
        });
}

export const postNewBank = (bankToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBankResponse = axiosConfig.post("/bankcompany/postNewBank",bankToPost);
            resolve(postedBankResponse)

        }catch(e){
            console.log(e);
            reject(Error("it broke"))
        }
    })
}

export const patchBank = (bankToPatch) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBankResponse = axiosConfig.patch("/bankcompany/updateBank",bankToPatch);
            resolve(postedBankResponse)

        }catch(e){
            console.log(e);
            reject(Error("it broke"))
        }
    })
}

/**
 * BRANCHES
 */

export const postNewBankBranch = (bankBranchToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBankBranchResponse = axiosConfig.post("/bankbranch/postnewbranch",bankBranchToPost);
            resolve(postedBankBranchResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};


export const patchBankBranch = (bankBranchToPatch) =>{
    return new Promise (async function (resolve,reject){
        try{
            let patchedBankBranchResponse = axiosConfig.patch("/bankbranch/updateBankBranch",bankBranchToPatch);
            resolve(patchedBankBranchResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};


/**
 * EMPLOYEES
 */

export const postNewBankBranchEE = (bankBranchEEToPost) => {
    return new Promise (async function (resolve,reject){
        try{
            let postedBankEEResponse = axiosConfig.post("/users/newUser",bankBranchEEToPost);
            resolve(postedBankEEResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};

export const patchBankBranchEE = (bankBranchEEToPatch) =>{
    return new Promise (async function (resolve,reject){
        try{
            let patchedBankBranchEEResponse = axiosConfig.patch("/users/patchupdateUser",bankBranchEEToPatch);
            resolve(patchedBankBranchEEResponse);

        }catch(e){
            console.log(e);
            reject(Error("it broke"));
        }
    })
};